// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CP6xxeCuYLDWYMQ3V9Pa {
  display: flex;
  overflow: hidden;
  flex-direction: column;
}

.g6EiPP2L4fmB5N3tJwQY {
  flex-grow: 1;
  display: flex;
  overflow: hidden;
  gap: 8px;
}

.g6EiPP2L4fmB5N3tJwQY > ul {
  flex-grow: 1;
  display: flex;
  list-style-type: none;
  padding: 0;

  overflow-x: scroll;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  -ms-overflow-style: none;
  scrollbar-width: none;
}

.g6EiPP2L4fmB5N3tJwQY > ul::-webkit-scrollbar {
  display: none;
}

.g6EiPP2L4fmB5N3tJwQY > ul > li {
  scroll-snap-align: start;
  width: 100%;
  flex-shrink: 0;
}

.IZwOZHiYA2smjs39PuQj {
  flex-grow: 0;
  border: none;
  color: var(--white-color);
  transition: 0.15s;
  background-color: var(--md-grey-color);
}

.IZwOZHiYA2smjs39PuQj:disabled {
  color: var(--grey-color-l);
}

.m3AO_O5dwYNptfP8zexV {
  font-size: 13px;
  text-align: center;
  margin-top: 0.5rem;
  user-select: none;
  -webkit-user-select: none;
  color: var(--white-color);
  margin-bottom: 1rem;
}

.m3AO_O5dwYNptfP8zexV input {
  display: inline-block;
  border: none;
  background: none;
  outline: none;
  padding: 0;
  color: currentColor;
  border-bottom: 1px solid currentColor;
  user-select: auto;
  -webkit-user-select: auto;
}

.m3AO_O5dwYNptfP8zexV .Zw1pv7xTgUfuUIrlQ8bf {
  display: inline-block;
}

.m3AO_O5dwYNptfP8zexV .Zw1pv7xTgUfuUIrlQ8bf::before {
  content: "/";
  margin: 0 0.25em;
}

.m3AO_O5dwYNptfP8zexV .zf_aJ7hIx_gqC16tjzQz {
  display: inline-block;
  visibility: hidden;
  position: fixed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ResultPage/components/SearchResultsList/components/Carousel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,UAAU;;EAEV,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,iCAAiC;;EAEjC,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,qCAAqC;EACrC,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".container {\n  display: flex;\n  overflow: hidden;\n  flex-direction: column;\n}\n\n.slideContainer {\n  flex-grow: 1;\n  display: flex;\n  overflow: hidden;\n  gap: 8px;\n}\n\n.slideContainer > ul {\n  flex-grow: 1;\n  display: flex;\n  list-style-type: none;\n  padding: 0;\n\n  overflow-x: scroll;\n  overflow-y: hidden;\n  scroll-snap-type: x mandatory;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.slideContainer > ul::-webkit-scrollbar {\n  display: none;\n}\n\n.slideContainer > ul > li {\n  scroll-snap-align: start;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.arrow {\n  flex-grow: 0;\n  border: none;\n  color: var(--white-color);\n  transition: 0.15s;\n  background-color: var(--md-grey-color);\n}\n\n.arrow:disabled {\n  color: var(--grey-color-l);\n}\n\n.paginationContainer {\n  font-size: 13px;\n  text-align: center;\n  margin-top: 0.5rem;\n  user-select: none;\n  -webkit-user-select: none;\n  color: var(--white-color);\n  margin-bottom: 1rem;\n}\n\n.paginationContainer input {\n  display: inline-block;\n  border: none;\n  background: none;\n  outline: none;\n  padding: 0;\n  color: currentColor;\n  border-bottom: 1px solid currentColor;\n  user-select: auto;\n  -webkit-user-select: auto;\n}\n\n.paginationContainer .total {\n  display: inline-block;\n}\n\n.paginationContainer .total::before {\n  content: \"/\";\n  margin: 0 0.25em;\n}\n\n.paginationContainer .inputWidthMeasurer {\n  display: inline-block;\n  visibility: hidden;\n  position: fixed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CP6xxeCuYLDWYMQ3V9Pa`,
	"slideContainer": `g6EiPP2L4fmB5N3tJwQY`,
	"arrow": `IZwOZHiYA2smjs39PuQj`,
	"paginationContainer": `m3AO_O5dwYNptfP8zexV`,
	"total": `Zw1pv7xTgUfuUIrlQ8bf`,
	"inputWidthMeasurer": `zf_aJ7hIx_gqC16tjzQz`
};
export default ___CSS_LOADER_EXPORT___;
